<!-- Request Exists Popup (reusable) -->
<div class="overlay12" [class.visible]="isOpen" (click)="onClose()"></div>

<div class="req-exists-overlay" *ngIf="isOpen">
  <div class="req-exists-container">
    <div class="div-with-close">
      <div class="req-header">
        <div class="req-second-header">

          <h3>Request already exists for {{ regNo }}</h3>
          <div class="req-tags">
            <div class="req-id">
              <div style="display: flex;align-items: center;">
                <svg style="width: 15px; height: 15px;opacity: 1;" width="17" height="21" viewBox="0 0 17 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5.47461 3.59735H3.47461C2.94418 3.59735 2.43547 3.80806 2.0604 4.18314C1.68532 4.55821 1.47461 5.06692 1.47461 5.59735V17.5974C1.47461 18.1278 1.68532 18.6365 2.0604 19.0116C2.43547 19.3866 2.94418 19.5974 3.47461 19.5974H13.4746C14.005 19.5974 14.5137 19.3866 14.8888 19.0116C15.2639 18.6365 15.4746 18.1278 15.4746 17.5974V5.59735C15.4746 5.06692 15.2639 4.55821 14.8888 4.18314C14.5137 3.80806 14.005 3.59735 13.4746 3.59735H11.4746M5.47461 3.59735C5.47461 4.12778 5.68532 4.63649 6.0604 5.01156C6.43547 5.38664 6.94418 5.59735 7.47461 5.59735H9.47461C10.005 5.59735 10.5137 5.38664 10.8888 5.01156C11.2639 4.63649 11.4746 4.12778 11.4746 3.59735M5.47461 3.59735C5.47461 3.06692 5.68532 2.55821 6.0604 2.18314C6.43547 1.80806 6.94418 1.59735 7.47461 1.59735H9.47461C10.005 1.59735 10.5137 1.80806 10.8888 2.18314C11.2639 2.55821 11.4746 3.06692 11.4746 3.59735M8.47461 10.5974H11.4746M8.47461 14.5974H11.4746M5.47461 10.5974H5.48461M5.47461 14.5974H5.48461" stroke="#1B5CA0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
              <div>Request #{{ existingRequest?.requestId }}</div>
            </div>
            <div class="req-status" [ngClass]="{
                  'requested': getOverallStatus(existingRequestItems) === '⏳ Requested',
                  'quote-received': getOverallStatus(existingRequestItems) === '💬 Quote Received',
                  'quote-approved': getOverallStatus(existingRequestItems) === '✅ Quote Approved',
                  'order-created': getOverallStatus(existingRequestItems) === '📦 Order Created'
                }">
              {{ getOverallStatus(existingRequestItems) }}
            </div>
            <div class="req-footer">
              <mat-icon class="req-close-icon" (click)="onClose()">close</mat-icon>
            </div>
          </div>
        </div>

        <p class="req-car-info">Car:
          {{ vehicleData?.make }} {{ vehicleData?.model }} • {{ vehicleData?.year }} • {{ vehicleData?.variant }} {{ vehicleData?.fuel }}
        </p>

        <p class="req-description">
          You can either start a fresh request or add your current parts to the existing one. Choose what suits you.
        </p>
      </div>
    </div>

    <!-- Two-column layout -->
    <h4>Existing request summary</h4>
    <div class="req-content">
      <!-- Left: Existing request summary -->
      <div class="req-summary">
        <div class="req-summary-header">
          <span class="req-created">
            Created: {{ getCreatedDate(existingRequest?.response?.body?.spareRequest?.created) }}
          </span>
        </div>

        <div class="req-items" [ngClass]="{ 'scrollable': showFullItems }">
          <div class="req-item" *ngFor="let item of getVisibleItems(existingRequestItems)">
            <span class="name">{{ item.itemName }}</span>
            <span class="qty">Qty: {{ item.itemQuantity }}</span>
          </div>
        </div>

        <button *ngIf="existingRequestItems.length > 3"
                class="view-full"
                (click)="toggleFullItems()">
          {{ showFullItems ? 'Show less' : 'View full request' }}
        </button>
      </div>

      <!-- Right: Actions -->
      <div class="req-actions">
        <h4>What would you like to do?</h4>
        <button class="btn fresh" (click)="onStartFresh()">Start a Fresh Request</button>
        <button class="btn add" (click)="onAddToExisting()">Add Items to Existing</button>
        <p class="tip">
          <strong>Tip:</strong> Fresh request keeps this one separate.<br />
          Add-to-Existing will merge the parts you're reviewing now into the above request.
        </p>
      </div>
    </div>
  </div>
  
</div>